<template>

    <div class="form-row">

        <!-- Parâmetros -->
        <template v-for="(input, index) in value" >

            <div v-if="false" :key="'T'  + index">{{ input }}</div>

            <div :key="index + 'pd'" class="col col-12 col-md-3" v-if="input.type == 'per-date'">
                <div class="form-group">
                    <az-input
                        :label="input.title"
                        type="select"
                        optionsMode="json"
                        :optionsList="input.options"
                        optionsData="0"
                        optionsDisplay="1"
                        :edicao="!input.disabled"
                        v-model="parametros[':' + input.id]"
                        @input="load()"
                    />
                </div>
            </div>

            <div :key="index + 'sel'" class="col col-12 col-md-3" v-else-if="input.type == 'select' || input.input_type == 'select'">
                <div class="form-group">
                    <az-input
                        :label="input.title"
                        :icon="translate_icon(input.meta_ope)"
                        type="select"
                        :placeholder="!input.required ? 'Todos...' : 'Selecione...'"
                        optionsMode="json"
                        :optionsList="input.options"
                        optionsData="0"
                        optionsDisplay="1"
                        :edicao="!input.disabled"
                        v-model="parametros[':' + input.id]"
                        @input="load()"
                    />
                </div>
            </div>

            <div :key="index + 'sel2'" class="col col-12 col-md-3" v-else-if="input.format == 'list-system' && input.service">
                <div class="form-group">
                    <az-input
                        :label="input.title"
                        :icon="( input.meta_ope && ( input.meta_ope == '<>' || input.meta_ope == 'not in' ) ) ? 'fas fa-not-equal' : ''"
                        :type="input.dd
                            ? ( ( typeof parametros[':' + input.id] === 'string' && parametros[':' + input.id].indexOf(',') > 0 ) ? 'text' : 'select' )
                            : 'autocomplete'"
                        :placeholder="!input.required ? 'Todos...' : 'Selecione...'"
                        optionsMode="aql"
                        :service="input.service"
                        :optionsData="service_key(input.service)"
                        :optionsParm="service_parms(input.service)"
                        :optionsName="service_name(input.service)"
                        optionsDisplay="search"
                        :edicao="!input.disabled"
                        v-model="parametros[':' + input.id]"
                        @input="load()">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="false && parametros[':' + input.id]">
                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="duplicar(input)">
                                    <i class="fa-solid fa-circle-plus"></i>
                                </button>
                            </div>

                            <div class="input-group-append" v-if="input.dd">
                                <button class="btn btn-outline-danger" type="button" id="button-addon2"
                                    @click="limpar(input)"
                                    v-if="input.dd
                                            && ( typeof parametros[':' + input.id] === 'string' && parametros[':' + input.id].indexOf(',') > 0 )">
                                    <i class="fa-solid fa-eraser"></i>
                                </button>

                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="selecionar_lista(input)">
                                    <i class="fa-solid fa-list-check"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div :key="index + 'selt2'" class="col col-12 col-md-3" v-else-if="input.format == 'list-tags' && input.service">
                <div class="form-group">
                    <az-input
                        :label="input.title"
                        :icon="( input.meta_ope && ( input.meta_ope == '<>' || input.meta_ope == 'not in' ) ) ? 'fas fa-not-equal' : ''"
                        :type="input.dd
                            ? ( ( typeof parametros[':' + input.id] === 'string' && parametros[':' + input.id].indexOf(',') > 0 ) ? 'text' : 'select' )
                            : 'autocomplete'"
                        :placeholder="!input.required ? 'Todos...' : 'Selecione...'"
                        optionsMode="aql"
                        :service="service_tags(input.service)"
                        :optionsParm="{ azi: 1 }"
                        optionsData="id"
                        optionsDisplay="search"
                        :edicao="!input.disabled"
                        v-model="parametros[':' + input.id]"
                        @input="load()">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="false && input.dd">
                                <button class="btn btn-outline-danger" type="button" id="button-addon2"
                                    @click="limpar(input)"
                                    v-if="input.dd
                                            && ( typeof parametros[':' + input.id] === 'string' && parametros[':' + input.id].indexOf(',') > 0 )">
                                    <i class="fa-solid fa-eraser"></i>
                                </button>

                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="selecionar_lista(input)" v-if="false">
                                    <i class="fa-solid fa-list-check"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
            </div>

            <div :key="index + 'time'" class="col col-12 col-md-3" v-else-if="input.type == 'per-time'">
                <div class="form-group">
                    <small class="text-muted">
                        {{ input.title }}
                    </small>
                    <div class="input-group">
                        <input type="time" aria-label="First name" class="form-control" :disabled="input.required == 'Fixo'" v-model="parametros[':' + input.id + '-from']" @input="debounce_load()">
                        <input type="time" aria-label="Last name" class="form-control" :disabled="input.required == 'Fixo'" v-model="parametros[':' + input.id + '-to']" @input="debounce_load()">
                    </div>
                </div>
            </div>

            <div :key="index + 'time1'" class="col col-12 col-md-3" v-else-if="input.type == 'datetime'">
                <div class="form-group">
                    <az-input type="datetime-local" :label="input.title" :edicao="input.required != 'Fixo'" v-model="parametros[':' + input.id]" @input="debounce_load()" />
                </div>
            </div>

            <div :key="index + 'time2'" class="col col-12 col-md-3" v-else-if="input.type == 'time' || input.type == 'date'">
                <div class="form-group">
                    <az-input :type="input.type" :label="input.title" :edicao="input.required != 'Fixo'" v-model="parametros[':' + input.id]" @input="debounce_load()" />
                </div>
            </div>

            <div :key="index + 'else'" class="col col-12 col-md-3" v-else>
                <div class="form-group">
                    <az-input
                        :icon="translate_icon(input.meta_ope)"
                        :label="input.title"
                        :edicao="input.required != 'Fixo'"
                        v-model="parametros[':' + input.id]"
                        @input="debounce_load()">
                    </az-input>
                </div>
            </div>

            <template v-if="input.type == 'per-date' && parametros[':' + input.id] == 'ld'">

                <div :key="index + 'per-de'" class="col col-12 col-md-3">
                    <div class="form-group">
                        <az-input label="Data" type="date" v-model="parametros[':' + input.id + '-from']" @input="load()" />
                    </div>
                </div>

            </template>

            <template v-else-if="input.type == 'per-date' && parametros[':' + input.id] == 'l'">

                <div :key="index + 'per-de'" class="col col-12 col-md-3">
                    <div class="form-group">
                        <az-input label="De" type="date" v-model="parametros[':' + input.id + '-from']" @input="load()" />
                    </div>
                </div>

                <div :key="index + 'per-ate'" class="col col-12 col-md-3">
                    <div class="form-group">
                        <az-input label="Até" type="date" v-model="parametros[':' + input.id + '-to']" @input="load()" />
                    </div>
                </div>

            </template>

            <template v-else-if="input.type == 'per-date' && parametros[':' + input.id] == 'lh'">

                <div :key="index + 'per-de'" class="col col-12 col-md-3">
                    <div class="form-group">
                        <az-input label="De" type="datetime-local" v-model="parametros[':' + input.id + '-from']" @input="load()" />
                    </div>
                </div>

                <div :key="index + 'per-ate'" class="col col-12 col-md-3">
                    <div class="form-group">
                        <az-input label="Até" type="datetime-local" v-model="parametros[':' + input.id + '-to']" @input="load()" />
                    </div>
                </div>

            </template>

            <div :key="index + 'per-mes'" class="col col-12 col-md-3" v-else-if="input.type == 'per-date' && parametros[':' + input.id] == 'lm'">
                <div class="form-group">
                    <az-input label="Mês" type="month" v-model="parametros[':' + input.id + '-mes']" @input="load()" />
                </div>
            </div>

        </template>

        <div class="col col-12 col-md-2 d-flex align-items-end">

            <button class="btn btn-primary my-3 mr-2" @click="load()"
                :disabled="$store.state.loading" v-if="1 == 0 && !is_dashboard"
                data-toggle="tooltip" data-placement="top" title="Buscar">
                <i class="fas fa-sync-alt" v-if="!$store.state.loading"></i>
                <div class="spinner-border spinner-border-sm" role="status" v-else>
                  <span class="sr-only">Loading...</span>
                </div>
            </button>

            <button class="btn btn-outline-primary dropdown-toggle my-3 mr-2" id="print-button-landscape"
                data-toggle="dropdown" data-placement="top" aria-haspopup="true" aria-expanded="false" title="Imprimir" v-if="!is_dashboard">
                <i class="fas fa-print"></i>
            </button>

            <div class="dropdown-menu" aria-labelledby="print-button-landscape">
                <a class="dropdown-item" href="#" @click="printTabela()"><i class="fas fa-portrait mr-2"></i>Retrato</a>
                <a class="dropdown-item" href="#" @click="printTabela(true)"><i class="fas fa-image mr-2"></i>Paisagem</a>
                <template v-if="etiquetas && etiquetas.length">
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item" href="#" v-for="etq in etiquetas" :key="'eta'+etq.id_etiqueta" @click="printEtiqueta(etq.id_etiqueta_layout)" ><i class="fas fa-tags mr-2"></i>{{etq.st_titulo}}</a>
                </template>
            </div>

            <button class="btn btn-outline-primary my-3 mr-2" @click="share()" v-if="1 == 0">
                <i class="fas fa-share"></i>
            </button>

            <fileExcel
                v-if="1 == 0"
                class="btn btn-outline-primary my-3 mr-2"
                :data="dataToDownload"
                :name="arquivoXls"
                :fields="fieldsToFile"
                :before-generate="checkFields"
                >
                <i class="fas fa-file-excel"></i>
            </fileExcel>

            <button class="btn btn-outline-primary my-3 mr-2" v-if="1 == 0">
                <i class="fas fa-clock"></i>
            </button>

            <slot></slot>
        </div>

        <!-- Fim de Parâmetros -->

        <!-- Seleção de Lista -->
        <div class="modal fade" id="selecaoParmListaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="filtro_edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Lista:
                            {{ filtro_edicao.title }}
                            <span class="badge badge-secondary ml-2" v-if="1==0 && filtro_edicao.opcoes">
                                {{ filtro_edicao.opcoes.filter(item => item.selec).length }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="filtro_edicao.opcoes">

                            <az-input
                                sizing="sm"
                                type="button-group"
                                :optionsList="[
                                    { id: 'T', search: 'Todos' },
                                    { id: 'S', search: 'Selecionados' },
                                ]"
                                v-model="filtro_edicao.tipo_exibicao"
                                @input="filtro_edicao.search = ''" />

                            <az-input
                                sizing="sm"
                                icon="fa fa-search"
                                placeholder="Pesquisar..."
                                v-model="filtro_edicao.search">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon2">
                                            <span v-if="lista_filtro_edicao.length != filtro_edicao.opcoes.length" title="Filtrados">
                                                {{ lista_filtro_edicao.length }}
                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            </span>

                                            <span title="Selecionados">
                                                {{ filtro_edicao.opcoes.filter(item => item.selec).length }}/{{ filtro_edicao.opcoes.length }}
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </az-input>

                            <table class="table table-sm border-0 table-responsive mb-2" v-if="filtro_edicao.classes && filtro_edicao.classes.length">
                                <tr>
                                    <td class="text-nowrap">
                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in filtro_edicao.classes" :key="icx">
                                            <span class="badge badge-success mr-1" >
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <az-empty-state
                                v-if="( !lista_filtro_edicao || !lista_filtro_edicao.length )"
                                icon="fa-solid fa-list-check"
                                msg="Nenhum item identificado." />

                            <template v-else>

                                <button type="button" class="btn btn-outline-primary btn-sm mb-2" @click="marcar_todos()">
                                    Todos
                                </button>

                                <div class="row" v-for="(opcao, iox) in lista_filtro_edicao" :key="iox">
                                    <div class="col co-12">
                                        <az-input
                                            sizing="sm"
                                            type="checkbox-group"
                                            :label="opcao.search"
                                            v-model="opcao.selec" />
                                    </div>
                                </div>

                            </template>
                        </template>

                        <pre v-if="false">{{ filtro_edicao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_lista_opcoes()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data () {
        return {
            parametros: {},
            fisrt: false,
            timeout: null,
            filtro_edicao: null,
        }
    },

    components: {
        AzInput,
        AzEmptyState,
    },

    props: ['value', 'is_dashboard', 'etiquetas'],

    watch: {
        value: {
            handler: function (newValue) {
                if ( newValue ) {
                    newValue.forEach(element => {
                        this.parametros[':' + element.id] = element.value;
                    });
                }
            },
            deep: true,
            immediate: true,
        },
    },

    computed: {
        lista_filtro_edicao: function () {
            if ( !this.filtro_edicao || !this.filtro_edicao.opcoes )
                return [];

            let reg = this.$util.getregex(this.filtro_edicao.search);

            return this.filtro_edicao.opcoes.filter(item => this.filtro_edicao.tipo_exibicao == 'T' || item.selec)
                .filter (item => {
                    return ( !this.filtro_edicao.search || reg.test(JSON.stringify(item)) );
                });
        },
    },

    methods: {
        limpar (input) {
            this.parametros[':' + input.id] = '';
            this.$forceUpdate();
        },

        selecionar_lista_opcoes () {
            let lista = this.filtro_edicao.opcoes.filter(item => item.selec)
                .map(item => item[this.service_key(this.filtro_edicao.service)]);

            this.parametros[':' + this.filtro_edicao.id] = lista.join(',');
            this.$forceUpdate();
            $('#selecaoParmListaModal').modal('hide');
        },

        marcar_todos () {
            let todos = this.lista_filtro_edicao.find(item => item.selec) ? false : true;

            this.lista_filtro_edicao.forEach(item => {
                item.selec = todos;
            });
        },

        filtrar (texto) {
            if ( this.filtro_edicao.search == '"' + texto + '"' ) {
                this.filtro_edicao.search = "";
            } else {
                this.filtro_edicao.search = '"' + texto + '"';
            }

            this.$forceUpdate();
        },

        selecionar_lista(filtro, index) {
            this.filtro_edicao = null;

            let valor = this.parametros[':' + filtro.id] + '';
            let lista = valor ? valor.split(',') : [];
            let selecteds = {};

            lista.forEach(element => {
                selecteds[element] = true;
            });

            this.$nextTick(() => {
                let service = filtro.service.split('.');

                let filtro_edicao = _.cloneDeep(filtro);

                filtro_edicao = _.cloneDeep(filtro);
                filtro_edicao.opcoes = [];
                filtro_edicao.index = index;
                filtro_edicao.tipo_exibicao = 'T';
                filtro_edicao.search = "";

                this.$util.loadItem(this, {
                    service: service[0],
                    func: service[1],
                    parms: {
                        ativos: true,
                        agenda: true,
                        ...this.service_parms(filtro.service),
                    }
                })
                .then(res => {
                    filtro_edicao.opcoes = _.orderBy(
                        res.map(item => {
                            item.selec = selecteds[item[this.service_key(filtro_edicao.service)]] ? true : false;
                            return item;
                        }),
                        'search'
                    );

                    filtro_edicao.classes = _.uniq(
                            filtro_edicao.opcoes.flatMap(item => item.js_classes ? item.js_classes : [])
                        ).sort();
                })
                .finally(() => {
                    this.filtro_edicao = _.cloneDeep(filtro_edicao);
                    $('#selecaoParmListaModal').modal('show');
                    //this.$forceUpdate();
                });
            });
        },

        translate_icon (oper) {
            switch (oper) {
                case '<>':
                case 'not in':
                    return 'fas fa-not-equal';

                case '>=': return 'fa-solid fa-greater-than-equal';
                case '>': return 'fa-solid fa-greater-than';
                case '<=': return 'fa-solid fa-less-than-equal';
                case '<': return 'fa-solid fa-less-than';
                default: return '';
            }
        },
        duplicar (input) {
            this.value.push(input);
        },

        service_tags ($service) {
            return $service.replace('.index', '.tags');
        },

        service_name (service) {
            switch (service) {
                case 'unidade_operacaos.index': return 'unidades-tags-relatorio';
            }

            return ''; 
        },

        service_key (service) {
            switch (service) {
                case 'apoiados.index': return 'id_apoiado';
                case 'tarefa_grupos.index': return 'id_tarefa_grupo';
                case 'especialidades.index': return 'id_especialidade';
                case 'operadoras.index': return 'id_operadora';
                case 'medicos.index': return 'id_pessoa';
                case 'planos.index': return 'id_plano';
                case 'procedimentos.index': return 'id_procedimento';
                case 'recepcaos.index': return 'id_recepcao';
                case 'unidade_operacaos.index': return 'id_unidade_operacao';
                case 'estoque_grupos.index': return 'id_estoque_grupo';
                case 'procedimento_grupos.index': return 'id_procedimento_grupo';
                case 'medico_solicitantes.index': return 'id_medico_solicitante';
                default: return 'id';
            }
        },

        service_parms (service) {
            switch (service) {
                case 'recepcaos.index': return { filtros: 1, ativos: 1 };
                case 'unidade_operacaos.index': return { classes: 1, ativos: 1 };
                default: return { ativos: 1 };
            }
        },

        add_parm_value () {
            //let novo = _.cloneDeep(input);

            //this.$set(this.parametros, ':' + novo.id + '|2', novo);
        },

        debounce_load() {
            console.log('debounce');

            if ( this.timeout )
                clearTimeout(this.timeout);

            this.timeout = setTimeout(() => {
                this.timeout = null;
                this.load();
            }, 700);

        },
        load() {
            this.$forceUpdate();

            if ( !this.first ) {
                this.first = true;
            } else {
                if ( this.is_dashboard && 1 == 0 )
                    this.$emit('carregar', this.parametros);
            }
        },

        printTabela(landscape = null) {
            this.$emit('imprimir', landscape);
        },

        printEtiqueta(etqid) {
            this.$emit('imprimirEtiqueta', etqid);
        },

        obter_parametros() {
            return this.parametros;
        }

    },

    mounted() {
        if ( !this.is_dashboard )
            this.first = true;
    }
}
</script>
